import { render, staticRenderFns } from "./quick-shop.vue?vue&type=template&id=54932c70&scoped=true&lang=pug&"
import script from "./quick-shop.vue?vue&type=script&lang=coffee&"
export * from "./quick-shop.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54932c70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
